export default __webpack_public_path__ + "static/media/element_13.1afffea2.webp";